import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useToggleStore } from '../hooks/useTogger';
import { AlignJustify } from 'lucide-react';

function TitlePage() {
  const [title, setTitle] = useState<string>('');
  const location = useLocation();
  const { toggle } = useToggleStore();

  useEffect(() => {
    if (location.pathname) {
      switch (location.pathname) {
        case '/admin/manage-employees':
          document.title = 'Quản lý nhân viên';
          setTitle('Quản lý nhân viên');
          break;
        case '/admin/manage-customers':
          document.title = 'Quản lý khách hàng';
          setTitle('Quản lý khách hàng');
          break;
        case '/admin/manage-suppliers':
          document.title = 'Quản lý nhà cung cấp';
          setTitle('Quản lý nhà cung cấp');
          break;
        case '/admin/manage-orders':
          document.title = 'Quản lý đơn hàng';
          setTitle('Quản lý đơn hàng');
          break;
        case '/admin/manage-gifts':
          document.title = 'Quản lý quà tặng';
          setTitle('Quản lý quà tặng');
          break;
        case '/admin/manage-gift-requests':
          document.title = 'Quản lý yêu cầu tặng quà';
          setTitle('Quản lý yêu cầu tặng quà');
          break;
        case '/admin/manage-roles':
          document.title = 'Quản lý phân quyền';
          setTitle('Quản lý phân quyền');
          break;
        case '/admin/change-password':
          document.title = 'Đổi mật khẩu';
          setTitle('Đổi mật khẩu');
          break;
        case '/admin/dashboard':
          document.title = 'Tổng quan';
          setTitle('Tổng quan');
          break;
        default:
          document.title = 'AiDay CRM';
          setTitle('AiDay CRM');
          break;
      }
    }
  }, [location.pathname]);
  return (
    <div>
      <div className="flex items-center gap-2">
        <div
          onClick={() => {
            toggle();
          }}
          className="cursor-pointer"
        >
          <AlignJustify />
        </div>
        <h3 className="text-2xl font-bold">{title}</h3>
      </div>
    </div>
  );
}

export default TitlePage;
